interface Window {
	STRIPE_3M_LINK: string;
	STRIPE_1M_LINK: string;
	STRIPE_7D_LINK: string;

	STRIPE_3M_PRICE_ID: string;
	STRIPE_1M_PRICE_ID: string;
	STRIPE_7D_PRICE_ID: string;

	STRIPE_30_DISCOUNT_CODE: string;
	STRIPE_40_DISCOUNT_CODE: string;
	STRIPE_50_DISCOUNT_CODE: string;

	STRIPE_30_DISCOUNT_ID: string;
	STRIPE_40_DISCOUNT_ID: string;
	STRIPE_50_DISCOUNT_ID: string;

	API_GEN_STRIPE_LINK: string;
	API_GEN_SOLIDGATE_LINK: string;
	API_GEN_SOLIDGATE_MERCHANT_DATA: string;

	API_ENTERED_CHECKOUT: string;
	API_ADD_EMAIL: string;
	API_PAGE_VIEW: string;
}

function _composeStripeLink(urlBase: string, prefilledPromoCode: string | null, email: string | null): string {
	let searchParams = new URLSearchParams();

	searchParams.set('client_reference_id', getSessionId());

	if (prefilledPromoCode) {
		searchParams.set('prefilled_promo_code', prefilledPromoCode);
	}

	if (email) {
		searchParams.set('prefilled_email', email);
	}

	for (const [key, value] of new URLSearchParams(window.location.search)) {
		if (key.startsWith('utm_')) {
			searchParams.set(key, value);
		}
	}

	return `${urlBase}?${searchParams.toString()}`;
}

function _getCheckoutLinkStripe(plan: string, email: string | null): string | null {
	let urlBase: string | null = null;
	let prefilledPromoCode: string | null = null;

	if (plan === 'getplan-3month') {
		urlBase = window.STRIPE_3M_LINK;
		prefilledPromoCode = window.STRIPE_40_DISCOUNT_CODE;
	} else if (plan === 'getplan-1month') {
		urlBase = window.STRIPE_1M_LINK;
		prefilledPromoCode = window.STRIPE_40_DISCOUNT_CODE;
	} else if (plan === 'getplan-7day') {
		urlBase = window.STRIPE_7D_LINK;
		prefilledPromoCode = window.STRIPE_40_DISCOUNT_CODE;
	} else if (plan === 'getplan-50%') {
		urlBase = window.STRIPE_1M_LINK;
		prefilledPromoCode = window.STRIPE_50_DISCOUNT_CODE;
	} else if (plan === 'getplan-40%') {
		urlBase = window.STRIPE_1M_LINK;
		prefilledPromoCode = window.STRIPE_40_DISCOUNT_CODE;
	} else if (plan === 'getplan-30%') {
		urlBase = window.STRIPE_1M_LINK;
		prefilledPromoCode = window.STRIPE_30_DISCOUNT_CODE;
	}

	if (!urlBase) {
		console.warn(`_getCheckoutLinkStripe: unknown plan ${plan}`);
		return null;
	}

	const url = _composeStripeLink(urlBase, prefilledPromoCode, email);

	console.log(`_getCheckoutLinkStripe: ${url}`);
	return url;
}

function _yetiRequestOptionsCreate(body: {}): RequestInit {
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');

	const raw = JSON.stringify({
		referrer: window.location.href,
		session_id: getSessionId(),
		...body,
	});

	return {
		method: 'POST',
		headers: headers,
		body: raw,
	};
}

function _getCheckoutDynLinkStripe(plan: string, email: string | null): Promise<string | null> {
	let priceId: string | null = null;
	let prefilledPromoCode: string | null = null;

	if (plan === 'getplan-3month') {
		priceId = window.STRIPE_3M_PRICE_ID;
		prefilledPromoCode = window.STRIPE_40_DISCOUNT_ID;
	} else if (plan === 'getplan-1month') {
		priceId = window.STRIPE_1M_PRICE_ID;
		prefilledPromoCode = window.STRIPE_40_DISCOUNT_ID;
	} else if (plan === 'getplan-7day') {
		priceId = window.STRIPE_7D_PRICE_ID;
		prefilledPromoCode = window.STRIPE_40_DISCOUNT_ID;
	} else if (plan === 'getplan-50%') {
		priceId = window.STRIPE_1M_PRICE_ID;
		prefilledPromoCode = window.STRIPE_50_DISCOUNT_ID;
	} else if (plan === 'getplan-40%') {
		priceId = window.STRIPE_1M_PRICE_ID;
		prefilledPromoCode = window.STRIPE_40_DISCOUNT_ID;
	} else if (plan === 'getplan-30%') {
		priceId = window.STRIPE_1M_PRICE_ID;
		prefilledPromoCode = window.STRIPE_30_DISCOUNT_ID;
	}

	if (!priceId) {
		console.warn(`_getCheckoutDynLinkStripe: unknown plan ${plan}`);
		return Promise.resolve(null);
	}

	const requestOptions = _yetiRequestOptionsCreate({
		email: email,
		price_id: priceId,
		promotion_code: prefilledPromoCode,
	});

	return fetch(window.API_GEN_STRIPE_LINK, requestOptions)
		.then((response) => response.json())
		.then((json) => json.url)
		.then((url) => {
			console.log(`_getCheckoutDynLinkStripe: ${url}`);
			return url;
		})
		.catch((error) => {
			console.warn(`_getCheckoutDynLinkStripe: ${error}`);
			return null;
		});
}

function _getSolidProductDetails(plan: string): { productId: string | null; price: number } {
	let productId: string | null = null;
	let price: number = 0;

	if (plan === 'getplan-7day') {
		productId = '952d9252-1b4a-4d85-963b-7598e021d2c4';
		price = 11.7;
	} else if (plan === 'getplan-1month') {
		productId = '912165aa-e450-4ae9-8096-d0bdd234086e';
		price = 17.7;
	} else if (plan === 'getplan-3month') {
		productId = '4e22f4c9-637f-4fdc-a2b8-4be8ab929634';
		price = 35.7;
	} else if (plan === 'getplan-50%') {
		productId = '63bb630f-f748-4443-9358-b6ced9a2eec3';
		price = 14.75;
	} else if (plan === 'getplan-40%') {
		productId = '912165aa-e450-4ae9-8096-d0bdd234086e';
		price = 17.7;
	} else if (plan === 'getplan-30%') {
		productId = '8a071ad3-65d8-46b8-bdc7-6e2d3e11b7cd';
		price = 20.65;
	} else if (plan === 'trial-free') {
		productId = 'eecfe2bd-da75-4171-b0ba-217759893b8a';
		price = 0.0;
	} else if (plan === 'trial-1') {
		productId = '60e5ac0f-8318-4e43-8bab-54de50f5e512';
		price = 1;
	} else if (plan === 'trial-11') {
		productId = 'f9624079-d116-43b8-9593-5534e249ee65';
		price = 11;
	} else if (plan === 'trial-16') {
		productId = '8d3f15c6-d145-4679-828c-ef4e1ee005e0';
		price = 16.41;
	} else if (plan === 'test') {
		productId = '4e49af0b-fc9e-4556-aa9c-43d86662dcc2';
		price = 1.0;
	}

	return { productId, price };
}

function _getCheckoutDynLinkSolid(plan: string, email: string | null, userName: string | null): Promise<string | null> {
	const { productId, price } = _getSolidProductDetails(plan);

	if (!productId) {
		console.warn(`_getCheckoutDynLinkSolid: unknown plan ${plan}`);
		return Promise.resolve(null);
	}

	if (userName == null) {
		userName = 'Customer';
	}

	if (!email || !userName) {
		console.warn('_getCheckoutDynLinkSolid: missing user data');
		return Promise.resolve(null);
	}

	const requestOptions = _yetiRequestOptionsCreate({
		email: email,
		first_name: userName,
		product_id: productId,
		price: price,
	});

	return fetch(window.API_GEN_SOLIDGATE_LINK, requestOptions)
		.then((response) => response.json())
		.then((json) => json.url)
		.then((url) => {
			console.log(`_getCheckoutDynLinkSolid: ${url}`);
			return url;
		})
		.catch((error) => {
			console.warn(`_getCheckoutDynLinkSolid: ${error}`);
			return null;
		});
}

interface CheckoutLinkOptions {
	useStatic?: boolean;
	useSolidGate?: boolean;
}

function _getCheckoutLink(
	plan: string,
	email: string | null,
	userName: string | null,
	options?: CheckoutLinkOptions,
): Promise<string | null> {
	if (options?.useStatic) {
		return new Promise((resolve) => resolve(_getCheckoutLinkStripe(plan, email)));
	}

	const dynLinkPromise = options?.useSolidGate
		? _getCheckoutDynLinkSolid(plan, email, userName)
		: _getCheckoutDynLinkStripe(plan, email);

	return dynLinkPromise.then((checkoutLink) => {
		if (checkoutLink) {
			return checkoutLink;
		} else {
			return _getCheckoutLinkStripe(plan, email);
		}
	});
}

function getCheckoutLinkAndReport(
	plan: string,
	email: string | null,
	userName: string | null,
	options?: CheckoutLinkOptions,
): Promise<string | null> {
	const getCheckoutLinkPromise = _getCheckoutLink(plan, email, userName, options);
	const reportCheckoutPromise = reportCheckout(plan);
	const timeoutPromise = new Promise((resolve) =>
		setTimeout(() => {
			resolve(null);
			console.warn('reportCheckout: timed out');
		}, 2000),
	); // 2 seconds timeout for reportCheckout if getCheckoutLink is done

	return Promise.race([
		Promise.all([getCheckoutLinkPromise, reportCheckoutPromise]),
		Promise.all([getCheckoutLinkPromise, timeoutPromise]),
	]).then(([checkoutLink]) => checkoutLink);
}

function getSolidGateMerchantData(plan: string, email: string | null, userName: string | null): {} | null {
	const { productId, price } = _getSolidProductDetails(plan);

	if (!productId) {
		console.warn(`getSolidGateMerchantData: unknown plan ${plan}`);
		return Promise.resolve(null);
	}

	if (userName == null) {
		userName = 'Customer';
	}

	if (!email || !userName) {
		console.warn('getSolidGateMerchantData: missing user data');
		return Promise.resolve(null);
	}

	const requestOptions = _yetiRequestOptionsCreate({
		email: email,
		first_name: userName,
		product_id: productId,
		price: price,
	});

	return fetch(window.API_GEN_SOLIDGATE_MERCHANT_DATA, requestOptions)
		.then((response) => response.json())
		.then((data) => {
			data['paymentIntent'] = data['payment_intent'];
			delete data['payment_intent'];
			return data;
		})
		.catch((error) => {
			console.warn(`getSolidGateMerchantData: ${error}`);
			return null;
		});
}

function _n8nHeadersCreate(): Headers {
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('Authorization', 'Basic dzJ3OmVkb3llemFlN2VpUjhqYWlwdWZv');
	return headers;
}

function _getCookie(name): string | null {
	let cookies = document.cookie.split(';');
	for (let i = 0; i < cookies.length; i++) {
		let cookie = cookies[i].trim();
		if (cookie.startsWith(name + '=')) {
			return cookie.substring(name.length + 1);
		}
	}
	return null;
}

function getSessionId(): string {
	// Check if the user already has a session id in session storage
	const existingSessionID = sessionStorage.getItem('sessionId');

	if (existingSessionID) {
		return existingSessionID;
	}

	const newSessionId = 'id_' + Math.random().toString(16).slice(2);

	sessionStorage.setItem('sessionId', newSessionId);

	return newSessionId;
}

function _getEventId(): string {
	return 'event_' + Math.random().toString(16).slice(2);
}

function _n8nRequestOptionsCreate(body: {}): RequestInit {
	const headers = _n8nHeadersCreate();
	const raw = JSON.stringify({
		referrer: window.location.href,
		fbp: _getCookie('_fbp'),
		fbc: _getCookie('_fbc'),
		sessionId: getSessionId(),
		...body,
	});

	return {
		method: 'POST',
		headers: headers,
		body: raw,
		redirect: 'follow',
	};
}

function reportCheckout(plan: string): Promise<void> {
	const eventId = _getEventId();
	trackEvent(
		'InitiateCheckout',
		{
			product: plan,
			content_type: 'product',
			content_ids: ['subscription'],
		},
		eventId,
	);

	const requestOptions = _n8nRequestOptionsCreate({ eventId });

	return fetch(window.API_ENTERED_CHECKOUT, requestOptions)
		.then(() => console.log('reportCheckout: success'))
		.catch((error) => console.warn(`reportCheckout: ${error}`));
}

function reportEmail(email: string, firstName: string, answers: {}[]): Promise<void> {
	if (!email) {
		return Promise.resolve();
	}

	const eventId = _getEventId();
	trackEvent('Lead', { email, first_name: firstName }, eventId);

	const requestOptions = _n8nRequestOptionsCreate({
		eventId,
		email,
		firstName,
		answers,
	});

	return fetch(window.API_ADD_EMAIL, requestOptions)
		.then(() => console.log('reportEmail: success'))
		.catch((error) => console.warn(`reportEmail: ${error}`));
}

function reportPageView(): Promise<void> {
	const eventId = _getEventId();
	trackEvent('PageView', { address: window.location.href }, eventId);

	const requestOptions = _n8nRequestOptionsCreate({ eventId });

	return fetch(window.API_PAGE_VIEW, requestOptions)
		.then(() => console.log('reportPageView: success'))
		.catch((error) => console.warn(`reportPageView: ${error}`));
}
